module.exports = ".search {\n  z-index: 1000;\n  cursor: pointer;\n  padding: 10px;\n  font-family: sans-serif;\n  opacity: 0.98;\n  background: white; }\n\n.search-result {\n  padding: 4px;\n  font-size: 15px; }\n\n.search-result:hover {\n  background: #d9edf7; }\n\n.label {\n  font-size: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/auto-complete/auto-complete.component.scss
// module id = ./src/app/components/auto-complete/auto-complete.component.scss
// module chunks = main